import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ITimeClockEvent } from '~/utils/interface/timeClock';
import { DEFAULT_PAGE, ROWS_PER_PAGE } from '~/utils/constants/common';
import { handleGetTimeClocks } from './timeClocksThunk';
import { SortField } from '~/utils/types/common';

export interface TimeClocksState {
  timeClocks: Array<ITimeClockEvent>;
  currentPage: number;
  totalPages: number;
  selectedIds: Array<string>;
  menuSelectedId: string | undefined;
  openAlertDelete: boolean;
  needRefreshData: boolean;
  filter: ITimeclockFilter;
}

export interface ITimeclockFilter {
  page?: number;
  limit?: number;
  search?: string;
  searchFields?: Array<string>;
  sort?: Array<SortField>;
}

const initialState: TimeClocksState = {
  timeClocks: [],
  currentPage: DEFAULT_PAGE,
  totalPages: 0,
  menuSelectedId: undefined,
  selectedIds: [],
  openAlertDelete: false,
  needRefreshData: false,
  filter: {
    page: 1,
    limit: ROWS_PER_PAGE,
    search: '',
    searchFields: [],
    sort: [],
  },
};

const timeClocksSlice = createSlice({
  name: 'timeClocks',
  initialState,
  reducers: {
    setFilter(state, action: PayloadAction<ITimeclockFilter>) {
      state.filter = { ...state.filter, ...action.payload };
    },
    setFilterProperty(
      state,
      action: PayloadAction<{ key: keyof ITimeclockFilter; value: ITimeclockFilter[keyof ITimeclockFilter] }>
    ) {
      if (state.filter[action.payload.key] !== action.payload.value) {
        state.filter = { ...state.filter, ...{ [action.payload.key]: action.payload.value } };
      }
    },
    changeSelectedIds(state, action: PayloadAction<Array<string>>) {
      state.selectedIds = [...action.payload];
    },
    changeOpenAlertDelete(state, action: PayloadAction<boolean>) {
      state.openAlertDelete = action.payload;
    },
    changeMenuSelectId(state, action: PayloadAction<string>) {
      state.menuSelectedId = action.payload;
    },
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleGetTimeClocks.pending, (state, action) => {
        state.selectedIds = [];
      })
      .addCase(handleGetTimeClocks.fulfilled, (state, action) => {
        state.timeClocks = [...action.payload.responses];
        state.currentPage = action.payload.pagination.page;
        state.totalPages = action.payload.pagination.totalPages;
        state.needRefreshData = false;
      })
      .addCase(handleGetTimeClocks.rejected, (state, action) => {});
  },
});

export const timeClocksActions = timeClocksSlice.actions;

const timeClocksReducer = timeClocksSlice.reducer;
export default timeClocksReducer;
